import { fetchIndexReadings as fetchIndexReadingsAPI } from "../API/IndexReadings";
import { store } from "../store";

/**
 * Récupère les relevés d'index pour un device et met à jour le store Redux
 * @param {string} dev_eui - EUI du device
 * @param {number} limit - Nombre maximum de relevés (défaut: 100)
 * @returns {Promise<Array>} - Liste des relevés
 */
export default async function fetchIndexReadings(dev_eui, limit = 100) {
  try {
    const result = await fetchIndexReadingsAPI(dev_eui, limit);

    store.dispatch({
      type: "indexReadings/updateForDevice",
      payload: {
        dev_eui: dev_eui,
        readings: result ? result : [],
      },
    });

    return result;
  } catch (error) {
    console.error("Erreur lors du fetch des relevés d'index:", error);
    return [];
  }
}
